import { instanceBo, transformAxiosError } from "../utils/axios.create";
import { AppVersion, SaveAppVersion } from "../domain/appVersion.interface";

const BASE = "/app-versions";

/**
 * SIMS-9441 — the app versions catalog is shared by every account, so its API
 * is not under `/accounts/{accountId}`. Requests still go through `instanceBo`
 * for the bearer token and the 401 refresh; only the base URL is overridden.
 */
const GLOBAL = { baseURL: process.env.REACT_APP_BACKEND_URL_BO };

const getAll = async (): Promise<AppVersion[]> => {
	return instanceBo
		.get(BASE, GLOBAL)
		.then((res) => res.data.body ?? [])
		.catch((err) => Promise.reject(transformAxiosError(err)));
};

/** Current version of each component; components without one are absent. */
const getCurrent = async (): Promise<AppVersion[]> => {
	return instanceBo
		.get(`${BASE}/current`, GLOBAL)
		.then((res) => res.data.body ?? [])
		.catch((err) => Promise.reject(transformAxiosError(err)));
};

const create = async (data: SaveAppVersion): Promise<AppVersion> => {
	return instanceBo
		.post(BASE, data, GLOBAL)
		.then((res) => res.data.body)
		.catch((err) => Promise.reject(transformAxiosError(err)));
};

const update = async (
	id: string,
	data: SaveAppVersion,
): Promise<AppVersion> => {
	return instanceBo
		.put(`${BASE}/${id}`, data, GLOBAL)
		.then((res) => res.data.body)
		.catch((err) => Promise.reject(transformAxiosError(err)));
};

const remove = async (id: string): Promise<void> => {
	return instanceBo
		.delete(`${BASE}/${id}`, GLOBAL)
		.then(() => undefined)
		.catch((err) => Promise.reject(transformAxiosError(err)));
};

const setCurrent = async (id: string): Promise<AppVersion> => {
	return instanceBo
		.patch(`${BASE}/${id}/current`, undefined, GLOBAL)
		.then((res) => res.data.body)
		.catch((err) => Promise.reject(transformAxiosError(err)));
};

export const appVersionService = {
	getAll,
	getCurrent,
	create,
	update,
	remove,
	setCurrent,
};
